<template>
 <div class="charts-container">
        <template v-if="chartDataList.length > 0">
          <el-row :gutter="16">
            <template v-for="(item,index) in chartDataList">
              <div :key="index">
                <el-col :span="item.policyId === 489 ?  12:item.policyId === 183 ? 12:6">
                  <ContentBox :title="item.policyName" style="height:342px">
                    <template v-if="item.policyId !== 489 && item.policyId !== 183">
                      <ve-ring
                        :data="item.ringChartsData"
                        :loading="loading"
                        :legend="ringcharts.legend"
                        :settings="ringcharts.settings"
                        :extend="ringcharts.extend"
                      >
                        <ChartDataEmpty v-if="!loading && item.ringChartsData.rows.length === 0" />
                      </ve-ring>
                    </template>
                    <template v-else>
                      <VeHistogram
                        :data="item.ringChartsData"
                        :loading="loading"
                        :settings="histogram.settings"
                        :extend="histogram.extend"
                      >
                        <ChartDataEmpty v-if="!loading && item.ringChartsData.rows.length === 0" />
                      </VeHistogram>
                    </template>
                  </ContentBox>
                </el-col>
              </div>
            </template>
          </el-row>
        </template>
        <template v-else>
          <ContentBox >
          <div class="no-message">
            <ChartDataEmpty />
          </div>
          </ContentBox>
        </template>
    </div>
</template>
<script>
import ChartDataEmpty from '@/components/ChartDataEmpty'
import VeRing from 'v-charts/lib/ring.common'
import VeHistogram from 'v-charts/lib/histogram.common.js'
import 'echarts/lib/component/legendScroll'
import 'v-charts/lib/style.css'
export default {
  components: {
    VeRing,
    ChartDataEmpty,
    VeHistogram
  },
  data() {
    return {
      ringcharts: {
        extend: {
          tooltip: {
            confine: true
          }
        },
        legend: {
          show: false
        },
        settings: {
          radius: ['25%', '44%'],
          offsetY: '120px',
          labelLine: {
            legend: 100
          }
        }
      },
      histogram: {
        extend: {
          tooltip: {
            confine: true
          },
          color: ['#1890FF'],
          legend: {
            show: false
          },
          grid: {
            top: '2%',
            bottom: '40%'
          },
          yAxis: {
            splitLine: {
              lineStyle: { type: 'dashed' }
            }
          },
          xAxis: {
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        },
        settings: {
          yAxisType: ['percent']
        }
      },
      chartDataList: [],
      loading: false
    }
  },
  props: {
    scheduleChartData: {
      type: Object
    }
  },
  watch: {
    scheduleChartData: {
      handler(newValue, oldValue) {
        this.fetchData()
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      if (this.scheduleChartData.orderId) {
        this.loading = true
        const form = {
          orderId: this.scheduleChartData.orderId,
          scheduleId: this.scheduleChartData.scheduleId,
          showType: this.scheduleChartData.showType,
          beginDate: this.$moment(this.scheduleChartData.time[0]).format('YYYY-MM-DD'),
          endDate: this.$moment(this.scheduleChartData.time[1]).format('YYYY-MM-DD')
        }
        this.$service.getCrowdReport(form).then(data => {
          this.loading = false
          if (data) {
            this.chartDataList = []
            for (let i = 0; i < data.crowdAnalysisList.length; i++) {
              this.chartDataList.push({
                policyName: data.crowdAnalysisList[i].policyName,
                policyId: data.crowdAnalysisList[i].policyId,
                ringChartsData: {
                  columns: [],
                  rows: []
                }
              })
              this.chartDataList[i].ringChartsData.columns = [
                data.crowdAnalysisList[i].policyName,
                'pv'
              ]
              for (
                let j = 0;
                j < data.crowdAnalysisList[i].crowdList.length;
                j++
              ) {
                this.chartDataList[i].ringChartsData.rows.push({
                  [data.crowdAnalysisList[i].policyName]:
                    data.crowdAnalysisList[i].crowdList[j].crowdName,
                  pv: data.crowdAnalysisList[i].crowdList[j].ratio
                })
              }
            }
            let orderSort = [487, 181, 489, 183, 182, 490, 185, 188, 189, 191]
            this.chartDataList = this.chartDataList.sort(function (a, b) {
              if (orderSort.indexOf(a.policyId) === -1) {
                orderSort.push(a.policyId)
              }
              return (
                orderSort.indexOf(a.policyId) - orderSort.indexOf(b.policyId)
              )
            })
            this.loading = false
          }
        })
      }
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
.charts-container {
  background: #f2f2f2;
  padding: 16px 16px 0;
  overflow: auto;
  height: calc(100vh - 176px);
}
.no-message {
  text-align: center;
  height: 300px;
}
</style>
